import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShellEffects {
  dispatchLoadPolicySuccess$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        // ofType(ShellActions.loadPolicySuccess),
        // tap(({ policy }) => {
        //   // this._shellStore.dispatchUpdateStages(policy.stages);
        // })
      ),
    { dispatch: false }
  );

  // private _shellStore = inject(ShellStore);

  constructor(private actions$: Actions) {}
}
